import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-27df6cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top page-default page-media" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-search" }, null, -1))
const _hoisted_4 = ["placeholder", "onKeydown"]
const _hoisted_5 = {
  key: 0,
  class: "search-drop"
}
const _hoisted_6 = {
  key: 0,
  class: "part"
}
const _hoisted_7 = { class: "label" }
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = {
  key: 1,
  class: "part"
}
const _hoisted_10 = { class: "label" }
const _hoisted_11 = ["onMousedown"]
const _hoisted_12 = {
  key: 0,
  class: "right c-thirdary"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar signOut",
  src: _imports_0
}, null, -1))
const _hoisted_14 = {
  class: "link",
  style: {"margin-left":"10px"}
}
const _hoisted_15 = {
  key: 1,
  class: "mine-menu"
}
const _hoisted_16 = { class: "info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "avatar",
  src: _imports_0
}, null, -1))
const _hoisted_18 = {
  class: "c-primary",
  style: {"font-size":"16px"}
}
const _hoisted_19 = { class: "c-thirdary" }
const _hoisted_20 = { class: "options c-primary" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tool-history" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-shoucang" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-pen" }, null, -1))
const _hoisted_24 = { class: "options c-primary" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gonggao" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tool-history" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-tip" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-tuichudenglu1" }, null, -1))
const _hoisted_29 = {
  key: 2,
  class: "playbacks"
}
const _hoisted_30 = { class: "title c-primary" }
const _hoisted_31 = ["onMousedown"]
const _hoisted_32 = { class: "line1" }
const _hoisted_33 = { class: "line1 c-secondary" }
const _hoisted_34 = { class: "c-thirdary" }

import { RootState, showLogin } from '@/store';
import i18, { State as I18State } from '@/store/i18';
import playbacks, { State as PlaybackState } from '@/store/mine/playbacks';
import movieSearch, { State } from '@/store/movies/search';
import user, { State as UserState } from '@/store/user';
import { ViewContext } from '@/views';
import Poster from '@/views/components/Poster.vue';
import * as filters from '@/views/filters';
import * as links from '@/views/links';
import { computed, inject, onMounted, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const context = inject('context') as ViewContext;

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].movieTop)

const common = computed<RootState>(() => store.state)
const searchData = computed<State>(() => store.state[movieSearch.name])
const userData = computed<UserState>(() => store.state[user.name]);
const playbackData = computed<PlaybackState>(() => store.state[playbacks.name]);
const state = reactive({
    search: '',
    mineMenuVisible: false,
    playbackVisible: false,
    lastRoute: '',
    searchHistory: [] as string[],
    searchHistoryVisible: false
})

onMounted(() => {
    state.search = searchData.value.keywords
    let s = window.localStorage.getItem('search')
    if (s) {
        try {
            state.searchHistory = JSON.parse(s)
        } catch (e) {
        }
    }
})

watch(() => searchData.value.keywords, () => {
    state.search = searchData.value.keywords
})

function showMineMenu() {
    state.mineMenuVisible = true;
    document.onmousedown = function () {
        document.onmousedown = null;
        state.mineMenuVisible = false;
    }
}

function showPlayback() {
    playbacks.loadList(store)
    state.playbackVisible = true;
    document.onmousedown = function () {
        document.onmousedown = null;
        state.playbackVisible = false
    }
}

function onFocusSearch() {
    state.searchHistoryVisible = true
}

function onBlurSearch() {
    state.searchHistoryVisible = false
}

function doSearch() {
    if (state.search) {
        if (state.searchHistory.indexOf(state.search) == -1) {
            state.searchHistory.unshift(state.search)
            if (state.searchHistory.length > 3) {
                state.searchHistory.pop()
            }
            window.localStorage.setItem('search', JSON.stringify(state.searchHistory))
        }
        let type = searchData.value.type
        if (route.name != 'movies/search') {
            type = '1'
        }
        router.push({
            name: 'movies/search',
            params: {
                type: type,
                kw: state.search
            }
        })
    }
}

function onSelectedWord(value: string) {
    state.search = value
    doSearch()
}

function clearSearchHistory() {
    window.localStorage.removeItem('search')
    state.searchHistory = []
}

function doLogin() {
    showLogin(store)
}

function doShare() {

}

function doLogout() {
    user.logout(store);
    router.push('/')
}

function doGo(path: string) {
    router.push(path)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search) = $event)),
        placeholder: _unref(lang).search_placeholder,
        onFocus: onFocusSearch,
        onBlur: onBlurSearch,
        onKeydown: _withKeys(doSearch, ["enter"])
      }, null, 40, _hoisted_4), [
        [_vModelText, _unref(state).search]
      ]),
      _createElementVNode("a", {
        class: "search-btn",
        onClick: doSearch
      }, _toDisplayString(_unref(lang).search), 1),
      (_unref(state).searchHistoryVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(state).searchHistory.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(lang).search_history), 1),
                    _createElementVNode("a", { onMousedown: clearSearchHistory }, _toDisplayString(_unref(lang).search_clear), 33)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).searchHistory, (item) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "hot",
                      onMousedown: ($event: any) => (onSelectedWord(item))
                    }, _toDisplayString(item), 41, _hoisted_8))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            (_unref(common).moviesConfig.hotsearch.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(lang).search_words), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(common).moviesConfig.hotsearch, (item, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "hot",
                      onMousedown: ($event: any) => (onSelectedWord(item))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ p: i < 3 })
                      }, _toDisplayString(i + 1), 3),
                      _createTextVNode(_toDisplayString(item), 1)
                    ], 40, _hoisted_11))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(common).moviesConfig.ucenter)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(userData).info)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("a", {
                  class: "icon i-tool-history link",
                  onClick: showPlayback
                }),
                _createElementVNode("img", {
                  class: "avatar",
                  onClick: showMineMenu,
                  src: _imports_0
                })
              ]))
            : _createCommentVNode("", true),
          (!_unref(userData).info)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "right c-thirdary",
                onClick: doLogin
              }, [
                _hoisted_13,
                _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(lang).login), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(userData).info && _unref(state).mineMenuVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(userData).info.nickname), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(userData).info.username), 1),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: "c-app",
                onMousedown: _cache[1] || (_cache[1] = ($event: any) => (doGo('/mine')))
              }, _toDisplayString(_unref(lang).my_profile), 33)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[2] || (_cache[2] = ($event: any) => (doGo('/mine/playbacks')))
            }, [
              _hoisted_21,
              _createTextVNode(_toDisplayString(_unref(lang).my_play), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[3] || (_cache[3] = ($event: any) => (doGo('/mine/favorites')))
            }, [
              _hoisted_22,
              _createTextVNode(_toDisplayString(_unref(lang).my_favorite), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[4] || (_cache[4] = ($event: any) => (doGo('/mine/notes')))
            }, [
              _hoisted_23,
              _createTextVNode(_toDisplayString(_unref(lang).my_note), 1)
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[5] || (_cache[5] = ($event: any) => (doGo('/mine/news')))
            }, [
              _hoisted_25,
              _createTextVNode(_toDisplayString(_unref(lang).notices), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[6] || (_cache[6] = ($event: any) => (doGo('/mine/about')))
            }, [
              _hoisted_26,
              _createTextVNode(_toDisplayString(_unref(lang).about), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: _cache[7] || (_cache[7] = ($event: any) => (doGo('/mine/suggest')))
            }, [
              _hoisted_27,
              _createTextVNode(_toDisplayString(_unref(lang).suggest), 1)
            ], 32),
            _createElementVNode("a", {
              class: "link",
              onMousedown: doLogout
            }, [
              _hoisted_28,
              _createTextVNode(_toDisplayString(_unref(lang).quit), 1)
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(state).playbackVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("b", null, _toDisplayString(_unref(lang).play_records), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(playbackData).list.slice(0, 5), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item link line",
              onMousedown: ($event: any) => (doGo(_unref(links).player(item.movid, item.urlid, item.duration)))
            }, [
              _createVNode(Poster, {
                url: item.movie.thumb,
                theme: "album"
              }, null, 8, ["url"]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("b", null, _toDisplayString(item.movie.title), 1)
              ]),
              _createElementVNode("div", _hoisted_33, _toDisplayString(item.url.title), 1),
              _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(filters).leftTime(item.duration)), 1)
            ], 40, _hoisted_31))
          }), 256)),
          _createElementVNode("a", {
            class: "more link c-thirdary",
            onMousedown: _cache[8] || (_cache[8] = ($event: any) => (doGo('/mine/playbacks')))
          }, _toDisplayString(_unref(lang).all_records), 33)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})